<div class="modal-header">
    <h4 class="modal-title" *ngIf="!reorderRule.id">ADD NEW RULE</h4>
    <h4 class="modal-title" *ngIf="reorderRule.id">EDIT RULE</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="container">
    <div class="row">
        <div class="col-12">
            <div class="modal-body" [formGroup]="reorderRuleForm">
                <div>
                    <div class="right w-50">
                        <input type="text" class="form-control" formControlName="name">
                    </div>
                    <div class="p-3">Rule name</div>
                </div>
                <div>
                    <div class="d-flex right w-50">
                        <div class="btn-group">
                            <button [ngClass]="sign === '-' ? 'btn-secondary' : 'btn-outline-secondary'" class="btn"
                                (click)="sign = '-';">-</button>
                            <button [ngClass]="sign === '+' ? 'btn-secondary' : 'btn-outline-secondary'" class="btn"
                                (click)="sign = '+'">+</button>
                        </div>
                        <div class="input-group ml-3">
                            <input class="form-control" type="number" min="0" formControlName="adjustment">
                            <div class="input-group-append">
                                <span class="input-group-text">%</span>
                            </div>
                        </div>
                    </div>
                    <div class="p-3">Adjustment</div>
                </div>
                <div class="py-2 px-3" *ngIf="locationsFormGroup">
                    <div class="right pt-2">
                        <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                            <label style="display: inline;">
                                <input type="checkbox" formControlName="minusInventory">
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div>
                        Minus inventory
                        <div ngbDropdown container="body" class="w-50">
                            <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer">Select locations</div>
                            <div ngbDropdownMenu class="p-3">
                                <ng-container [formGroup]="locationsFormGroup">
                                    <div class="d-flex" *ngFor="let location of locations.getAll()">
                                        <span class="kt-switch kt-switch--xs kt-switch--icon ml-2">
                                            <label style="display: unset;">
                                                <input type="checkbox" [id]="'loc' + location.id"
                                                    [formControlName]="location.id">
                                                <span></span>
                                            </label>
                                        </span>
                                        <div class="p-1">
                                            <label [attr.for]="'loc' + location.id"
                                                style="display: unset;">{{location.name}}</label>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="py-2 px-3" *ngIf="storesFormGroup">
                    <div class="right pt-2">
                        <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                            <label style="display: inline;">
                                <input type="checkbox" formControlName="minusStoreInventory">
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div>
                        Minus store inventory
                        <div ngbDropdown container="body" class="w-50">
                            <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer">Select stores</div>
                            <div ngbDropdownMenu class="p-3">
                                <ng-container [formGroup]="storesFormGroup">
                                    <div class="d-flex" *ngFor="let store of stores.getAll()">
                                        <span class="kt-switch kt-switch--xs kt-switch--icon ml-2">
                                            <label style="display: unset;">
                                                <input type="checkbox" [id]="'store' + store.id"
                                                    [formControlName]="store.id">
                                                <span></span>
                                            </label>
                                        </span>
                                        <div class="p-1">
                                            <label [attr.for]="'store' + store.id"
                                                style="display: unset;">{{store.name}}</label>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
               <div class="py-2 px-3" *ngIf="overstockedStoresFormGroup">
                    <div class="right pt-2">
                        <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                            <label style="display: inline;">
                                <input type="checkbox" formControlName="minusOverstockedStoreInventory"
                                    [attr.disabled]="overstockedDisabled">
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div>
                        Minus overstocked store inventory
                        <div ngbDropdown container="body" class="w-50">
                            <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer">Select stores</div>
                            <div ngbDropdownMenu class="p-3">
                                <ng-container [formGroup]="overstockedStoresFormGroup">
                                    <div class="d-flex" *ngFor="let store of stores.getAll()">
                                        <span class="kt-switch kt-switch--xs kt-switch--icon ml-2">
                                            <label style="display: unset;">
                                                <input type="checkbox" [id]="'overstocked-store' + store.id"
                                                    [formControlName]="store.id"
                                                    [attr.disabled]="storesFormGroup.value[store.id] ? null : false">
                                                <span></span>
                                            </label>
                                        </span>
                                        <div class="p-1">
                                            <label [attr.for]="'overstocked-store' + store.id"
                                                style="display: unset;">{{store.name}}</label>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-3">
                    <div class="right">
                        <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                            <label style="display: inline;">
                                <input type="checkbox" formControlName="minusOpenPurchases">
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div>
                        Minus PO's
                    </div>
                </div>
                <div class="p-3">
                    <div class="right">
                        <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                            <label style="display: inline;">
                                <input type="checkbox" formControlName="outOfStock">
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div>
                        Out of stock
                    </div>
                </div>
                <div class="p-3">
                    <div class="right">
                        <span class="kt-switch kt-switch--sm kt-switch--icon ml-2">
                            <label style="display: inline;">
                                <input type="checkbox" formControlName="buyBox">
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div>
                        Buy Box
                    </div>
                </div>
                <div class="p-3">
                    <div class="kt-margin-b-10">
                        Order For
                    </div>
                    <div class="form-group kt-margin-b-0">
                        <range-picker #orderFor [addYears]="5"></range-picker>
                    </div>
                </div>
                <div class="p-3">
                    <div class="kt-margin-b-10">
                        Based On
                    </div>
                    <div class="form-group kt-margin-b-0">
                        <range-picker #basedOn [addYears]="-5"></range-picker>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer d-flex">
    <div>
        <button class="btn btn-secondary bg-white" (click)="modal.dismiss()">Cancel</button>
        <button class="btn btn-brand kt-margin-l-15" (click)="saveRule()">Save rule</button>
    </div>
</div>
<!-- 
      <div class="modal-body" [formGroup]="reorderRuleForm">
        <div class="kt-margin-b-20">
          <div class="sub-title-14 kt-margin-b-10">
            Rule name
          </div>
          <input type="text" class="form-control" formControlName="name">
        </div>
        <div class="row">
          <div class="col-6">
            <div class="sub-title-14 kt-margin-b-10">
              Add to calculation
            </div>
            <div class="check-form kt-margin-r-25 kt-margin-b-15">
              <label class="custom-checkbox-container">
                <input type="checkbox" formControlName="outOfStock">
                <span class="checkbox-checkmark"></span>
                <span class="content-text-13-grey-1">+ Out of stock</span>
              </label>
            </div>
            <div class="check-form kt-margin-r-25 kt-margin-b-15">
              <label class="custom-checkbox-container">
                <input type="checkbox" formControlName="buyBox">
                <span class="checkbox-checkmark"></span>
                <span class="content-text-13-grey-1">+ Buy box</span>
              </label>
            </div>
            <div class="check-form kt-margin-r-25 kt-margin-b-15">
              <label class="custom-checkbox-container">
                <input type="checkbox" formControlName="minusInventory">
                <span class="checkbox-checkmark"></span>
                <span class="content-text-13-grey-1">- Inventory</span>
              </label>
              <div ngbDropdown container="body">
                <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer ml-5">Select locations</div>
                <div ngbDropdownMenu class="p-3">
                  <ng-container *ngIf="locationsFormGroup" [formGroup]="locationsFormGroup">
                      <div *ngFor="let location of locations.getAll()">
                        <label>
                          <input type="checkbox" [id]="'loc' + location.id" [formControlName]="location.id">
                          {{location.name}}
                        </label>
                      </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="check-form kt-margin-r-25 kt-margin-b-15">
              <label class="custom-checkbox-container">
                <input type="checkbox" formControlName="minusStoreInventory">
                <span class="checkbox-checkmark"></span>
                <span class="content-text-13-grey-1">- Store inventory</span>
              </label>
              <div ngbDropdown container="body">
                <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer ml-5">Select stores</div>
                <div ngbDropdownMenu class="p-3">
                  <ng-container *ngIf="storesFormGroup" [formGroup]="storesFormGroup">
                      <div *ngFor="let store of stores.getAll()">
                        <label>
                          <input type="checkbox" [id]="'store' + store.id" [formControlName]="store.id">
                          {{store.name}}
                        </label>
                      </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="check-form kt-margin-r-25 kt-margin-b-15">
              <label class="custom-checkbox-container">
                <input type="checkbox" formControlName="minusOverstockedStoreInventory"
                  [attr.disabled]="overstockedDisabled">
                <span class="checkbox-checkmark"></span>
                <span class="content-text-13-grey-1">- Overstocked Store inventory</span>
              </label>
              <div ngbDropdown container="body">
                <div ngbDropdownToggle class="hide kt-font-brand cursor-pointer ml-5">Select stores</div>
                <div ngbDropdownMenu class="p-3">
                  <ng-container *ngIf="overstockedStoresFormGroup" [formGroup]="overstockedStoresFormGroup">
                      <div *ngFor="let store of stores.getAll()">
                        <label>
                          <input type="checkbox" [formControlName]="store.id"
                            [attr.disabled]="storesFormGroup.value[store.id] ? null : false"> {{store.name}}
                        </label>
                      </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="check-form kt-margin-r-25 kt-margin-b-15">
              <label class="custom-checkbox-container">
                <input type="checkbox" formControlName="minusOpenPurchases">
                <span class="checkbox-checkmark"></span>
                <span class="content-text-13-grey-1">- Open Purchase Orders</span>
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="sub-title-14 kt-margin-b-10">
              Adjustments
            </div>
            <div class="form-group kt-margin-b-15">
              <div class="input-group">
                <div class="input-group-prepend">
                  <button [ngClass]="sign == '-' ? 'btn-secondary' : 'btn-outline-secondary'"
                    class="btn" (click)="sign = '-'">-</button>
                  <button [ngClass]="sign == '+' ? 'btn-secondary' : 'btn-outline-secondary'"
                    class="btn" (click)="sign = '+'">+</button>
                </div>
                <input type="text" class="form-control" formControlName="adjustment">
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
   -->